import { shuffle } from 'lodash';

export default shuffle;
